import { get } from 'underscore';
import { TARGET_TYPE, URL_RULES_OPTIONS } from '../helpers/constants';

export const extractTargetsFromViewModel = (assetGroupUrlRules) => {
  const targetMapping = {
    [TARGET_TYPE.Url]: [],
    [TARGET_TYPE.PageTitle]: [],
    [TARGET_TYPE.PageContent]: [],
    [TARGET_TYPE.Category]: [],
    [TARGET_TYPE.CustomLabel]: [],
  };

  assetGroupUrlRules.forEach((rule) => {
    const type = get(rule, 'TargetCondition1', '');
    const values = [get(rule, 'TargetValue1', ''), get(rule, 'TargetValue2', ''), get(rule, 'TargetValue3', '')]
      .filter(Boolean);

    if (targetMapping[type]) {
      targetMapping[type].push(values);
    }
  });

  return {
    urlTargets: targetMapping[TARGET_TYPE.Url],
    pageTitleTargets: targetMapping[TARGET_TYPE.PageTitle],
    pageContentTargets: targetMapping[TARGET_TYPE.PageContent],
    categoryTargets: targetMapping[TARGET_TYPE.Category],
    customLabelTargets: targetMapping[TARGET_TYPE.CustomLabel],
  };
};

export const getPlaceHolderText = (i18n, selectedTargetType) => {
  switch (selectedTargetType) {
    case TARGET_TYPE.Url:
      return i18n.getString(_TL_('Enter URL rule'));
    case TARGET_TYPE.PageTitle:
      return i18n.getString(_TL_('Enter page title'));
    case TARGET_TYPE.PageContent:
      return i18n.getString(_TL_('Enter page content'));
    case TARGET_TYPE.Category:
      return i18n.getString(_TL_('Enter category'));
    case TARGET_TYPE.CustomLabel:
      return i18n.getString(_TL_('Enter custom label'));
    default:
      return '';
  }
};

export const getUrlRulesOption = (assetGroupUrlRules) => {
  const {
    urlTargets,
    pageTitleTargets,
    pageContentTargets,
    categoryTargets,
    customLabelTargets,
  } = extractTargetsFromViewModel(assetGroupUrlRules);

  let urlRulesOption = URL_RULES_OPTIONS.All;
  if (urlTargets.length > 0 || pageTitleTargets.length > 0 || pageContentTargets.length > 0 || categoryTargets.length > 0) {
    urlRulesOption = URL_RULES_OPTIONS.Rules;
  } else if (customLabelTargets.length > 0) {
    urlRulesOption = URL_RULES_OPTIONS.Labels;
  }
  return urlRulesOption;
};
